// Components
import { Grid } from '@mui/material'

// Styles
import {
  Container,
  ContainerContent,
} from './styles'

// Utils
import { useTranslation } from 'react-i18next'

// Permissions
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../../../Context/PermissionsContext';
import { CustomButtonV2 } from '../../../../pages/styles';
import { FileUploadOutlined, SaveAltRounded } from '@mui/icons-material';

export const CharacteristicsForm = ({
  openAttachments,
  hideFiles,
  generatePdf
}) => {
  const { t } = useTranslation();
  const ability = useAbility(AbilityContext);

  return (
    <Container>
      <ContainerContent>
        <Grid item sm={6} md={7} lg={8} xl={9}></Grid>
        {!hideFiles &&
          <Grid item xs={12} sm={6} md={5} lg={4} xl={3}>
            <Grid container spacing={2}>
              {(ability.can("GetWorkflowDataFile") || ability.can("UploadWorkflowDataFile")) &&
                <Grid item xs={6}>
                  <CustomButtonV2
                    variant='contained'
                    onClick={openAttachments}
                    btnType="secondary"
                    startIcon={<FileUploadOutlined/>}
                  >
                    {t('forms.characteristics.loadFiles')}
                  </CustomButtonV2>
                </Grid>
              }
              <Grid item xs={6}>
                <CustomButtonV2
                    variant='contained'
                    onClick={generatePdf}
                    btnType="secondary"
                    startIcon={<SaveAltRounded/>}
                  >
                    {t('common.downloadPdf')}
                  </CustomButtonV2>
              </Grid>
            </Grid>
          </Grid>
        }
      </ContainerContent>
    </Container>
  )
}
